import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { DocumentRequests } from './document-request';

@Component({
  selector: 'cs-document-request',
  standalone: false,
  templateUrl: './document-request.component.html',
  styleUrls: ['./document-request.component.scss']
})
export class DocumentRequestComponent implements OnInit, OnDestroy {
  public documentRequests: Array<DocumentRequests>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;
  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getDocumentRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.documentRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: DocumentRequests): void {
    this.router.navigate(['/site/dms/document-requests/approval'], {
      queryParams: { requestId: request.requestId }
    });
    this.closeTodo.emit();
  }
}
